import React from 'react';
import ParkingRatePage from './ParkingRatePage.tsx';

const ParkingRateCreatePage: React.FC = () => (
  <ParkingRatePage isEditMode={false} />
);

export default ParkingRateCreatePage;
